import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import logo from "../../assets/img/logo-white.png";
import CustomModal from "../../components/CustomModal";

function StudentFirstRegistration() {
  const token = "123";

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      gender: "",
      nationality: "Pakistani",
      religion: "",
      guardianName: "",
      relation: "",
      occupation: "",
      guardianIdentityNo: "",
      mobileNo: "",
      email: "",
      countryId: "",
      stateId: "",
      cityId: "",
      centerId: "",
      centerClassId: "",
      sourceOfInformation: "",
      registrationNo: "",
      grandParentsName: "",
      code: "",
    },
  });

  const [age, setAge] = useState("");
  const [firstRegistrationDetails, setFirstRegistrationDetails] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const showModal = () => setModalVisible(true);
  const hideModal = () => setModalVisible(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [classesData, setClassesData] = useState([]);

  const selectedCountry = watch("countryId");
  const selectedState = watch("stateId");
  const selectedCity = watch("cityId");
  const selectedCenter = watch("centerId");

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get("Dropdown/GetCountries", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCountries(response);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry && selectedCountry.value) {
      const fetchStates = async () => {
        try {
          const response = await get(
            `Dropdown/GetStates?countryId=${selectedCountry.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setStates(response);

          setCities([]);
          setValue("stateId", null);
          setValue("cityId", null);
          setValue("centerId", null);
          setValue("centerClassId", null);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry, setValue, watch]);

  useEffect(() => {
    if (selectedState && selectedState.value) {
      const fetchCities = async () => {
        try {
          const response = await get(
            `Dropdown/GetCities?stateId=${selectedState.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setCities(response);

          setCentersData([]);
          setValue("cityId", null);
          setValue("centerId", null);
          setValue("centerClassId", null);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      fetchCities();
    }
  }, [selectedState, setValue, watch]);

  useEffect(() => {
    if (selectedCity && selectedCity.value) {
      const fetchCenters = async () => {
        try {
          const response = await get(
            `Center/GetCenterByCityId?cityId=${selectedCity.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setCentersData(response.center);

          setClassesData([]);
          setValue("centerId", null);
          setValue("centerClassId", null);
        } catch (error) {
          console.error("Error fetching centers:", error);
        }
      };

      fetchCenters();
    }
  }, [selectedCity, setValue, watch]);

  useEffect(() => {
    if (selectedCenter && selectedCenter.value) {
      const fetchClasses = async () => {
        try {
          const response = await get(
            `CenterClass/GetClassCenterByCenterId?id=${selectedCenter.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setClassesData(response);

          setValue("centerClassId", null);
        } catch (error) {
          console.error("Error fetching classes:", error);
        }
      };

      fetchClasses();
    }
  }, [selectedCenter, setValue, watch]);

  const genders = [
    {
      id: 1,
      name: "Male",
    },
    {
      id: 2,
      name: "Female",
    },
  ];

  const studentRelations = [
    {
      id: "Father",
      name: "Father",
    },
    {
      id: "Mother",
      name: "Mother",
    },
    {
      id: "Brother",
      name: "Brother",
    },
    {
      id: "Sister",
      name: "Sister",
    },
    {
      id: "Uncle",
      name: "Uncle",
    },
    {
      id: "Guardian",
      name: "Guardian",
    },
  ];

  const guardianOccupations = [
    {
      id: "Business",
      name: "Business",
    },
    {
      id: "Employed",
      name: "Employed",
    },
  ];

  const sourceOfInfoOptions = [
    {
      id: "Social Media",
      name: "Social Media",
    },
    {
      id: "Newspaper Ad",
      name: "Newspaper Ad",
    },
    {
      id: "Word of Mouth",
      name: "Word of Mouth",
    },
    {
      id: "Campus Visit",
      name: "Campus Visit",
    },
  ];

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);

    if (birthDate > today) {
      setAge("");
      return;
    }

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    // Adjust for negative months or days
    if (days < 0) {
      months -= 1;
      days += new Date(
        birthDate.getFullYear(),
        birthDate.getMonth() + 1,
        0
      ).getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    setAge(`${years} years, ${months} months, and ${days} days`);
  };

  const handleDateChange = (event) => {
    const dob = event.target.value;

    if (dob == "") {
      setAge("");
      return;
    }
    setValue("dateOfBirth", dob);
    calculateAge(dob);
  };

  const saveData = async (data) => {
    const formData = {
      ...data,
      countryId: data?.countryId?.value,
      stateId: data?.stateId?.value,
      cityId: data?.cityId?.value,
      centerId: data?.centerId?.value,
      centerClassId: data?.centerClassId?.value,
      gender: data?.gender?.value,
      occupation: data?.occupation?.value,
      relation: data?.relation?.value,
      sourceOfInformation: data?.sourceOfInformation?.value,
    };

    try {
      const response = await post("Registration", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success("Success!");
        setFirstRegistrationDetails(response?.registration);
        showModal();
        reset();
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <nav
        className="navbar navbar-top navbar-expand bg-brand"
        id="navbarDefault"
      >
        <div className="container">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="navbar-logo">
              <a className="navbar-brand me-1 me-sm-3" href="#">
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    <img
                      src={logo}
                      alt="phoenix"
                      width="120"
                      style={{ filter: "brightness(100)" }}
                    />
                  </div>
                </div>
              </a>
            </div>
            <div>
              <a className="btn bg-white btn-sm" href="/" target="_blank">
                School Management System
                <i className="fa-solid fa-arrow-up-right-from-square ms-1"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <div className="bg-white py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="sfr-form-wrapper">
                <h3 className="mb-5">Student First Registration</h3>
                <form className="row g-5" onSubmit={handleSubmit(saveData)}>
                  <div className="col-12">
                    <h4 className="text-brand mb-3">Student Information</h4>

                    <div className="row g-3">
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          First Name
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("firstName", {
                            required: "This field is required.",
                            maxLength: {
                              value: 75,
                              message: "Maximum of 75 characters allowed.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                          onChange={handleChangeOfInputWithLengthCheck(
                            "firstName"
                          )}
                        />
                        {errors.firstName && (
                          <small className="text-danger fs-9">
                            {errors.firstName.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Last Name
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("lastName", {
                            required: "This field is required.",
                            maxLength: {
                              value: 75,
                              message: "Maximum of 75 characters allowed.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                          onChange={handleChangeOfInputWithLengthCheck(
                            "lastName"
                          )}
                        />
                        {errors.lastName && (
                          <small className="text-danger fs-9">
                            {errors.lastName.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Date of Birth
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("dateOfBirth", {
                            required: "This field is required.",
                            validate: {
                              notFutureDate: (value) =>
                                (value && new Date(value) <= new Date()) ||
                                "Future dates are not allowed.",
                              notBefore2000: (value) =>
                                (value &&
                                  new Date(value) >= new Date("2000-01-01")) ||
                                "Dates before the year 2000 are not allowed.",
                            },
                          })}
                          type="date"
                          className="form-control form-control-lg"
                          min="2000-01-01" // Prevents selecting dates before 2000 in the date picker
                          max={new Date().toISOString().split("T")[0]} // Prevents selecting future dates
                          onChange={(e) => {
                            handleDateChange(e); // Custom logic if needed
                            trigger("dateOfBirth"); // Ensures validation runs on change
                          }}
                        />
                        {age && (
                          <div className="mt-2">
                            <strong>Age:</strong> {age}
                          </div>
                        )}
                        {errors.dateOfBirth && (
                          <small className="text-danger fs-9">
                            {errors.dateOfBirth.message}
                          </small>
                        )}
                      </div>

                      <div className="col-sm-12">
                        <label className="fw-bold mb-1 d-block">
                          Gender<span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`gender`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={genders.map((gender) => ({
                                value: gender.id,
                                label: gender.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`gender`, null);
                                } else {
                                  setValue(
                                    `gender`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`gender`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        <div>
                          {errors.gender && (
                            <small className="text-danger fs-9">
                              {errors.gender.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Nationality
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <select
                          {...register("nationality", {
                            required: "This field is required.",
                          })}
                          className="form-select form-select-lg"
                        >
                          <option key={0} value="">
                            Select
                          </option>
                          <option key="Pakistani" value="Pakistani">
                            Pakistani
                          </option>
                          <option key="Australian" value="Australian">
                            Australian
                          </option>
                        </select>
                        {errors.nationality && (
                          <small className="text-danger fs-9">
                            {errors.nationality.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Religion
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("religion", {
                            required: "This field is required.",
                            maxLength: {
                              value: 75,
                              message: "Maximum of 75 characters allowed.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                          onChange={handleChangeOfInputWithLengthCheck(
                            "religion"
                          )}
                        />
                        {errors.religion && (
                          <small className="text-danger fs-9">
                            {errors.religion.message}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="mt-5 border-2 border-top border-dashed"></div>

                    <h4 className="text-brand mb-3 mt-5">
                      Guardian Information
                    </h4>

                    <div className="row g-3">
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Name<span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("guardianName", {
                            required: "This field is required.",
                            maxLength: {
                              value: 75,
                              message: "Maximum of 75 characters allowed.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                          onChange={handleChangeOfInputWithLengthCheck(
                            "guardianName"
                          )}
                        />
                        {errors.guardianName && (
                          <small className="text-danger fs-9">
                            {errors.guardianName.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Relation
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`relation`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={studentRelations.map((relation) => ({
                                value: relation.id,
                                label: relation.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`relation`, null);
                                } else {
                                  setValue(
                                    `relation`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`relation`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.relation && (
                          <small className="text-danger fs-9">
                            {errors.relation.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1 d-block">
                          Identity Number
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("guardianIdentityNo", {
                            required: "This field is required.",
                            maxLength: {
                              value: 75,
                              message: "Maximum of 75 characters allowed.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                          onChange={handleChangeOfInputWithLengthCheck(
                            "guardianIdentityNo"
                          )}
                        />
                        {errors.guardianIdentityNo && (
                          <small className="text-danger fs-9">
                            {errors.guardianIdentityNo.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1 d-block">
                          Mobile Number
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("mobileNo", {
                            required: "This field is required.",
                            pattern: {
                              value:
                                /^(\+?(\d{1,3}))?(\(?\d{3}\)?[-.\s]?)?(\d{3})[-.\s]?(\d{4})$/, // Regex for phone number validation
                              message: "Please enter a valid mobile number.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                        />
                        {errors.mobileNo && (
                          <small className="text-danger fs-9">
                            {errors.mobileNo.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Email Address
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <input
                          {...register("email", {
                            required: "This field is required.",
                            maxLength: {
                              value: 75,
                              message: "Maximum of 75 characters allowed.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Please enter a valid email.",
                            },
                          })}
                          type="text"
                          className="form-control form-control-lg"
                          onChange={handleChangeOfInputWithLengthCheck("email")}
                        />
                        {errors.email && (
                          <small className="text-danger fs-9">
                            {errors.email.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Occupation
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`occupation`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={guardianOccupations.map(
                                (occupation) => ({
                                  value: occupation.id,
                                  label: occupation.name,
                                })
                              )}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`occupation`, null);
                                } else {
                                  setValue(
                                    `occupation`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`occupation`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.occupation && (
                          <small className="text-danger fs-9">
                            {errors.occupation.message}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="mt-5 border-2 border-top border-dashed"></div>

                    <h4 className="text-brand mb-3 mt-5">
                      Admission Information
                    </h4>

                    <div className="row g-3">
                      {/* <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          When is admission required?
                        <span className="text-danger fs-8 ms-1">*</span></label>
                        <input
                          {...register("admissionDate", {
                            required: "This field is required.",
                          })}
                          type="date"
                          className="form-control form-control-lg"
                        />
                        {errors.admissionDate && (
                          <small className="text-danger fs-9">
                            {errors.admissionDate.message}
                          </small>
                        )}
                      </div> */}
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Country
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`countryId`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={countries.map((country) => ({
                                value: country.id,
                                label: country.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`countryId`, null);
                                } else {
                                  setValue(
                                    `countryId`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`countryId`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.countryId && (
                          <small className="text-danger fs-9">
                            {errors.countryId.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          State<span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`stateId`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={states.map((state) => ({
                                value: state.id,
                                label: state.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`stateId`, null);
                                } else {
                                  setValue(
                                    `stateId`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`stateId`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.stateId && (
                          <small className="text-danger fs-9">
                            {errors.stateId.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          City<span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`cityId`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={cities.map((city) => ({
                                value: city.id,
                                label: city.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`cityId`, null);
                                } else {
                                  setValue(
                                    `cityId`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`cityId`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.cityId && (
                          <small className="text-danger fs-9">
                            {errors.cityId.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Center<span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`centerId`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={centersData.map((center) => ({
                                value: center.id,
                                label: center.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`centerId`, null);
                                } else {
                                  setValue(
                                    `centerId`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`centerId`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.centerId && (
                          <small className="text-danger fs-9">
                            {errors.centerId.message}
                          </small>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          Class<span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`centerClassId`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={classesData.map((classItem) => ({
                                value: classItem.id,
                                label: classItem.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`centerClassId`, null);
                                } else {
                                  setValue(
                                    `centerClassId`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`centerClassId`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.centerClassId && (
                          <small className="text-danger fs-9">
                            {errors.centerClassId.message}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="mt-5 border-2 border-top border-dashed"></div>

                    <h4 className="text-brand mb-3 mt-5">
                      Source of Information
                    </h4>

                    <div className="row g-3">
                      <div className="col-sm-12">
                        <label className="fw-bold mb-1">
                          How did you hear about us?
                          <span className="text-danger fs-8 ms-1">*</span>
                        </label>
                        <Controller
                          name={`sourceOfInformation`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={sourceOfInfoOptions.map(
                                (sourceOfInfoItem) => ({
                                  value: sourceOfInfoItem.id,
                                  label: sourceOfInfoItem.name,
                                })
                              )}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`sourceOfInformation`, null);
                                } else {
                                  setValue(
                                    `sourceOfInformation`,
                                    selectedOption || { value: 0, label: "" }
                                  );
                                }
                                trigger(`sourceOfInformation`);
                              }}
                              className="react-select-style-lg"
                              classNamePrefix="react-select-style-pref-lg"
                              // isClearable
                            />
                          )}
                        />
                        {errors.sourceOfInformation && (
                          <small className="text-danger fs-9">
                            {errors.sourceOfInformation.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting" : "Submit Information"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalVisible && (
        <CustomModal
          title="Student First Registration"
          content={
            <div className="fs-9">
              <p>
                Thank you for submitting the student information. We have
                successfully received the details for{" "}
                <strong>
                  {firstRegistrationDetails.firstName +
                    " " +
                    firstRegistrationDetails.lastName}
                </strong>
                .
              </p>
              <p>
                An email has been sent to the guardian's email address (
                <strong>{firstRegistrationDetails.email}</strong>), containing
                important information regarding the registration. This includes
                your unique registration number, which is:{" "}
                <strong>{firstRegistrationDetails.registrationNo}</strong>
              </p>
              <p>
                If you have any further questions, please feel free to contact
                us.
              </p>
            </div>
          }
          onClose={hideModal}
        />
      )}
    </>
  );
}

export default StudentFirstRegistration;
